import { useMutation as e } from "@maat/store-hooks";
import { authApi as t } from "@maat/api-main";
//#region src/queries/registration/useRegisterVerifyMutation.ts
var n = () => e({ mutationFn: t.registerVerify });
//#endregion
export { n as useRegisterVerifyMutation };
